import styled from 'styled-components';

const Wrapper = styled.div`
  .section1 {
    background: #e1e1e1;
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 11.6rem 20rem 0 20rem;

    .inner-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      max-width: 1200px;

      .item {
        align-items: center;
        color: #35447d;
        display: flex;
        font-size: 1.8rem;
        flex-wrap: wrap;
        position: relative;
        text-align: center;

        .description {
          font-family: Helvetica;
          margin-top: 2.5rem;
        }
      }
    }
  }

  .section2 {
    background: #f8f7f3;
    align-items: center;
    display: flex;
    height: 34.7rem;
    justify-content: center;
    padding: 0 25rem;

    .inner-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      max-width: 1090px;

      .description {
        align-items: center;
        display: flex;
        flex: 1;
        flex-wrap: wrap;

        h1 {
          color: #35447d;
          font-family: Helvetica;
          font-size: 2.8rem;
          font-weight: lighter;
          margin: 4rem;
          line-height: 4rem;

          span {
            font-weight: bold;
          }
        }
      }
    }
  }

  .section3 {
    align-items: center;
    background: #35447d;
    display: flex;
    flex-wrap: wrap;
    height: 47.5rem;
    justify-content: center;
    padding: 0 16rem;

    .inner-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      max-width: 1150px;

      .detail {
        .description {
          color: white;
          font-family: Poppins-Light;
          font-size: 3.4rem;
          text-align: left;

          span {
            font-weight: bold;
          }
        }
        .button-wrapper {
          display: flex;
          justify-content: flex-start;
          margin-top: 4rem;
        }
      }
      .image-wrapper {
        align-self: center;
        height: 26rem;
        ${'' /* margin-right: 4rem; */}
        width: 40rem;

        img {
          height: 100%;
          width: auto;
          margin: auto;
        }
      }
    }
  }

  @media only screen and (max-width: 1400px) {
    .section1 {
      padding: 8.6rem 10rem 0 10rem;

      .inner-wrapper {
        justify-content: space-around;
        max-width: 1000px;
      }
    }
    .section2 {
      height: auto;
      padding: 10rem 15rem;

      .inner-wrapper {
        max-width: 900px;

        .description {
          justify-content: space-around;
        } 
      }
    }
    .section3 {
      height: auto;
      flex-wrap: wrap;
      justify-content: center;
      padding: 10rem 10rem;

      .inner-wrapper {
        justify-content: center;

        .detail {
          margin: auto;
          text-align: center;

          .button-wrapper {
            justify-content: flex-start;
          }
        }
        .image-wrapper {
          margin: 5rem auto auto auto;
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .section1 {
      padding: 5.6rem 5rem 0 5rem;
    }
    .section2 {
      height: auto;
      padding: 6rem 10rem;
      
      .inner-wrapper {
        flex-direction: column;
        width: auto;

        .description {
          text-align: center;
        }
      }
    }
    .section3 {
      height: auto;
      flex-direction: column;
      padding: 10rem 10rem;
      .detail {
        text-align: center;
        .button-wrapper {
          justify-content: space-between;
        }
      }
      .image-wrapper {
        margin: 5rem 0 0 0;
      }
    }
  }
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./src/containers/HomePage/Wrapper.js